import Vue from "vue"
import {
  INIT_MENU,
  ENABLE_MENU_ACTIVE,
  DISABLE_MENU_ACTIVE,
  SET_MODULES,
  UPDATE_MENU,
  SET_APPLICATION,
  SET_MODULE_TYPES,
  SET_SYSTEM_MODULES
} from "./mutation-types"

export default {
  [INIT_MENU](state) {},
  [ENABLE_MENU_ACTIVE](state, { i }) {
    state.menu.children[i].isActive = true
  },
  [DISABLE_MENU_ACTIVE](state, { i }) {
    if (i === "all") {
      for (let key = 0; key < state.menu.children.length; key++) {
        if (state.menu.children[key].isActive === true) {
          state.menu.children[key].isActive = false
          break
        }
      }
    } else {
      state.menu.children[i].isActive = false
    }
  },
  [SET_MODULES](state, data) {
    let collectMenu =  state.menu.children.find(it => it.name === "收藏")
    Vue.set(collectMenu, "children", data.list)
    Vue.set(collectMenu, "collectTotal", data.total)
    // 同时保存分页总数
  },
  [UPDATE_MENU](state, data) {
    Vue.set(state.menu.children[0].children[data.child_index], "subs", data.newMenu)
  },
  [SET_APPLICATION](state, data) {
    Vue.set(state.menu.children[2].children[data.child_index], "children", data.newMenu)
  },
  [SET_MODULE_TYPES](state, data) {
    Vue.set(state.menu, "moduleTypes", data)
    let component = state.menu.children.find(item => item.name === "基础")
    data.forEach(item => {
      let curComponent = component.children.find(componentItem => item.name.indexOf(componentItem.name) > -1)
      if (curComponent) {
        curComponent.typeId = item.encId
      }
    })
  },

  [SET_SYSTEM_MODULES](state, data) {
    let element = state.menu.children.find(item => item.type === "element")
    let chileElement = element.children.find(item => item.typeId === data.type)
    if (!chileElement) {
      return
    }
    let list = chileElement.children
    for (let i = 0; i < list.length; i++) {
      if (list[i].attribute.options.isSystemComponent && !list[i].attribute.options.isDefaultComponent) {
        list.splice(i, 1)
        i--
      } else {
        list[i].attribute.options.componentTypeId = data.type
        list[i].attribute.options.name = chileElement.name
        list[i].attribute.options.componentTypeName = chileElement.type
      }
    }
    let localStylesLen = list.length
    data.list.forEach((rect, index) => {
      let param = {
        name: rect.title,
        cover: rect.cover,
        thumbnail: "",
        attribute: {
          ...JSON.parse(rect.content)
        }
      }
      if (!param.attribute.options) {
        param.attribute.options = {}
      }
      param.attribute.options.isSystemComponent = true
      param.attribute.options.isIndependenceComponent = chileElement.type === "swiperComponent" ? false : true
      param.attribute.options.componentTypeId = data.type
      param.attribute.options.componentTypeName = chileElement.type
      param.attribute.options.encId = rect.encId
      param.attribute.options.name = chileElement.name
      param.attribute.options.isDefaultComponent = false
      list.push(param)
    })
    Vue.set(chileElement, "children", list)
    Vue.set(chileElement, "localStylesLen", localStylesLen)
  }
}
